<script>
    import { store } from '../../store.js';
    import { onMount } from 'svelte';
    
    // import { style } from 'svelte-style-action';
    export let styles = { left: 200, top: 400, width: 'auto', height: 'auto'};
    export let name = 'na';
    export let id = null;

    let section;

    let moving = false;
	
	function onMouseDown(e) {
		moving = true;
	}
	
	function onMouseMove(e) {
		if (moving) {
            if(!styles) {
                styles = {
                    left: e.pageX, top: e.pageY, width: 'auto', height: 'auto'
                }
            }
            if(typeof styles.left === 'string') {
                styles.left = Number(styles.left.replace('px', '').trim());
            }

            if(typeof styles.top === 'string') {
                styles.top = Number(styles.top.replace('px', '').trim());
            }

			// styles.left += e.movementX;
			// styles.top += e.movementY;
            styles.left = e.pageX;
			styles.top = e.pageY;
		}
	}
	
	function onMouseUp(e) {
        if(moving) console.log(e);
		moving = false;
	}

    function randomColor() {
        return Math.floor(Math.random()*16777215).toString(16);
    }

    function style(node, initialVars) {
        let oldVars;

        function applyStyles(vars) {
            if (typeof vars === 'string') {
                if (!oldVars && !vars) {
                    // Do nothing if it's an empty string;
                    return;
                }

                node.style.cssText = vars;
                oldVars = vars;
                return;
            }

            vars = vars || {};
            
            for (let [k, v] of Object.entries(vars)) {
                if(!isNaN(v)) {
                    v = `${v * $store.r}px`;
                }
                
                if(typeof v === 'string') {
                    v = Number(v.replace('px', '').trim());
                    v = `${v * $store.r}px`;
                }
                node.style.setProperty(k, v);
            }

            if(!vars.left) {
                node.style.setProperty('left', '300px');
            }

            if(!vars.top) {
                node.style.setProperty('top', '300px');
            }

            for (let k of Object.keys(oldVars || {})) {
                if (!(k in vars)) {
                    // In the DOM, setting it to an empty string actually deletes it.
                    node.style.setProperty(k, '');
                }
            }

            oldVars = vars;
        }

        applyStyles(initialVars);

        return {
            update(newVars) {
            applyStyles(newVars);
            },
        };
    }

    function move(element) {
		
		return {
			destroy() {
			}
		}
	}
	
	function resize(element) {
		const right = document.createElement('div')
		right.direction = 'east'
		right.classList.add('grabber')
		right.classList.add('right')
		
		const left = document.createElement('div')
		left.direction = 'west'
		left.classList.add('grabber')
		left.classList.add('left')
		
		const top = document.createElement('div')
		top.direction = 'north'
		top.classList.add('grabber')
		top.classList.add('top')
		
		const bottom = document.createElement('div')
		bottom.direction = 'south'
		bottom.classList.add('grabber')
		bottom.classList.add('bottom')
		
		const topLeft = document.createElement('div')
		topLeft.direction = 'northwest'
		topLeft.classList.add('grabber')
		topLeft.classList.add('top-left')
		
		const topRight = document.createElement('div')
		topRight.direction = 'northeast'
		topRight.classList.add('grabber')
		topRight.classList.add('top-right')
		
		const bottomLeft = document.createElement('div')
		bottomLeft.direction = 'southwest'
		bottomLeft.classList.add('grabber')
		bottomLeft.classList.add('bottom-left')
		
		const bottomRight = document.createElement('div')
		bottomRight.direction = 'southeast'
		bottomRight.classList.add('grabber')
		bottomRight.classList.add('bottom-right')
				
		const grabbers = [right, left, top, bottom, topLeft, topRight, bottomLeft, bottomRight]
		
		let active = null, initialRect = null, initialPos = null
		
		grabbers.forEach(grabber => {
			element.appendChild(grabber)
			grabber.addEventListener('mousedown', onMousedown)
		})
		
		function onMousedown(event) {
            if(!$store.showGrabber) return
           
            active = event.target
            const rect = element.getBoundingClientRect()
            const parent = element.parentElement.getBoundingClientRect()
            
            console.log({rect, parent})
            
            initialRect = {
                width: rect.width,
                height: rect.height,
                left: rect.left - parent.left,
                right: parent.right - rect.right,
                top: rect.top - parent.top,
                bottom: parent.bottom - rect.bottom
            }
            initialPos = { x: event.pageX, y: event.pageY }
            active.classList.add('selected')			
		}
		
		function onMouseup(event) {
			if (!active) return
            if(!$store.showGrabber) return
			active.classList.remove('selected')
			active = null
			initialRect = null
			initialPos = null
		}
		
		function onMove(event) {
			if (!active) return
            if(!$store.showGrabber) return
			const direction = active.direction
			let delta
			
			if (direction.match('east')) {
				delta = event.pageX - initialPos.x
				element.style.width = `${initialRect.width + delta}px`				
			}
			
			if (direction.match('west')) {
				delta = initialPos.x - event.pageX
				element.style.left = `${initialRect.left - delta}px`
				element.style.width = `${initialRect.width + delta}px`
			}
			
			if (direction.match('north')) {
				delta = initialPos.y - event.pageY
				element.style.top = `${initialRect.top - delta}px`
				element.style.height = `${initialRect.height + delta}px`
			}
			
			if (direction.match('south')) {
				delta = event.pageY - initialPos.y
				element.style.height = `${initialRect.height + delta}px`
			}
		}
		
		window.addEventListener('mousemove', onMove)	
		window.addEventListener('mouseup', onMouseup)	
		
		return {
			destroy() {
				window.removeEventListener('mousemove', onMove)
				window.removeEventListener('mousemove', onMousedown)
				
				grabbers.forEach(grabber => {
					element.removeChild(grabber)
				})
			}
		}
	}
</script>

<svelte:window on:mouseup={($store.isDev && $store.showMover) && onMouseUp} on:mousemove={($store.isDev && $store.showMover) && onMouseMove} />

<div
    id= {id || null}
    bind:this={section}
    
    class={`section ${name}`}
    on:mousedown={($store.isDev && $store.showMover) && onMouseDown}
    class:draggable={$store.isDev && $store.showMover}

    class:grabber={$store.isDev && $store.showGrabber}
    class:hide-grabber={!$store.showGrabber}
    use:move
    use:resize
    
    use:style={styles}
    data-name={name}
    style:position="absolute"
    style="--section-name: '{name}'"

    style:background-color={($store.isDev && $store.showColor) ? `#${randomColor()}` : 'inherit'}
    class:showColor={$store.showColor}
    style:opacity={$store.isDev ? '1' : 'inherit'}
>
    <slot></slot>
</div>

<style>

.draggable {
    user-select: none;
    cursor: move;
    border: solid 1px gray;
    position: absolute;
}

.draggable::after {
    content: var(--section-name);
    display: inline-block;
    position: absolute;
    right: 0;
    background: black;
    color: white;
}

.showColor {
    background-color: transparent !important;
}

:global(.grabber) {
    position: absolute;
    box-sizing: border-box; 
}

:global(.grabber.right) {
    width: 10px;
    height: 100%;
    background: red;
    top: 0;
    right: -5px;
    cursor: col-resize;
}

:global(.grabber.left) {
    top: 0;
    width: 10px;
    height: 100%;
    background: blue;
    left: -5px;
    cursor: col-resize;
}

:global(.grabber.top) {
    height: 10px;
    width: 100%;
    background: green;
    top: -5px;
    cursor: row-resize;
}

:global(.grabber.bottom) {
    height: 10px;
    width: 100%;
    background: orange;
    bottom: -5px;
    cursor: row-resize;
}

:global(.grabber.top-left) {
    height: 20px;
    width: 20px;
    background: orange;
    top: -10px;
    left: -10px;
    cursor: nw-resize;
    border-radius: 100%;
}

:global(.grabber.top-right) {
    height: 20px;
    width: 20px;
    background: orange;
    top: -10px;
    right: -10px;
    cursor: ne-resize;
    border-radius: 100%;
}

:global(.grabber.bottom-left) {
    height: 20px;
    width: 20px;
    background: green;
    bottom: -10px;
    left: -10px;
    cursor: sw-resize;
    border-radius: 100%;
}

:global(.grabber.bottom-right) {
    height: 20px;
    width: 20px;
    background: green;
    bottom: -10px;
    right: -10px;
    cursor: se-resize;
    border-radius: 100%;
}

:global(.hide-grabber .grabber) {
    background: transparent !important;
    border: none !important;
    display: none;
}

:global(.grabber.selected) {
    border: solid 1px black;
}
    
</style>